module.exports = __webpack_public_path__ + "static/images/intro4_c8a6c977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/intro4.png
// module id = 232
// module chunks = 1